export default __webpack_public_path__ + "static/media/03-3D-Face.cdfe07ad.mp4";